<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    class="btn-primary"
    :class="{ 'w-full': fullWidth }"
  >
    <span v-if="loading" class="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
    <slot v-else />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: 'button' | 'submit';
    disabled?: boolean;
    loading?: boolean;
    fullWidth?: boolean;
  }>(),
  { type: 'button', disabled: false, loading: false, fullWidth: false }
);
</script>